import { TThunkDispatch } from "../../store/hooks";
import {
  getCurrentUser,
  registerUser,
  login,
  deleteUser,
  logoutUser,
  updateUsername,
  Creds,
  updateCountry } from "../../http/user";
import {
  updateCurrentCountry,
  updateCurrentUser } from "./user.slice";
import { updateFolders, updateProtocols } from '../protocol/protocol.slice';
import { updateListings, updateProductId } from '../listings/listings.slice';
import { TGetState } from '../store';


export const retrieveUserAsync = () => async(dispatch: TThunkDispatch) =>
{
  return getCurrentUser()
    .then(data =>
    {
      if(!data)
        return;

      dispatch(updateCurrentUser(data));
      return data;
    });
};

export const changeCountryAsync = (country: {
  countryId: number,
  currencyCode: string,
  currencySymbol: string }) => async(dispatch: TThunkDispatch) =>
{
  return updateCountry(country.countryId)
    .then(data =>
    {
      if(!data.success)
        throw(Error("Error updating country"));

      // Clear listings as they are country-specific
      dispatch(updateCurrentCountry(country));
      dispatch(updateListings(undefined));
      dispatch(updateProductId(undefined));
    })
    .catch(err => console.log(err));
};

export const validateLoginAsync = (creds: Creds, clearPublicProtocol = true) => async(dispatch: TThunkDispatch) =>
{
  if(clearPublicProtocol)
    dispatch(updateProtocols([]));

  return login(creds)
    .then(async data =>
    {
      if(!data?.success)
        return data;

      dispatch(updateListings(undefined));
      dispatch(updateProductId(undefined));
      dispatch(updateCurrentUser(data));

      return data;
    })
    .catch(async err => console.log("Error logging in:", err));
};

export const logoutAsync = () => async(dispatch: TThunkDispatch) =>
{
  dispatch(updateCurrentUser(undefined));
  dispatch(updateProtocols([]));
  dispatch(updateFolders([]));

  return logoutUser()
    .then(() => dispatch(retrieveUserAsync()))
    .catch(err => console.log(err));
};

export const changeUsernameAsync = (newUsername: string) => async(dispatch: TThunkDispatch) =>
{
  return updateUsername(newUsername)
    .then(data => data.success)
    .then(success =>
    {
      if(success && !success.usernameExists)
        return dispatch(retrieveUserAsync());
      else
        throw(Error("Error updating username"));
    })
    .catch(err => console.log(err));
};

export const registerNewUserAsync = (
  username: string,
  password: string,
  email: string) => async(dispatch: TThunkDispatch, getState: TGetState) =>
{
  const countryId = getState().user.countryId;

  return registerUser(username, password, email, countryId)
    .then(async(data: { success: boolean, usernameExists?: boolean, emailExists?: boolean }) =>
    {
      if(data.success)
        await dispatch(validateLoginAsync({ username: username, password: password }));

      return data;
    });
};

export const removeUserAsync = () => async(dispatch: TThunkDispatch) =>
{
  dispatch(updateProtocols([]));

  return deleteUser()
    .then(() => dispatch(retrieveUserAsync()))
    .catch(err => console.log(err));
};

